"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
exports.useStyles = (0, makeStyles_1.default)((theme) => ({
    textButton: {
        fontSize: 14,
        fontWeight: 600,
    },
    tableActions: {
        justifyContent: 'space-between',
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
        width: '100%',
        boxSizing: 'border-box',
        verticalAlign: 'top',
        display: 'flex',
        padding: '0 16px',
        '& svg': {
            cursor: 'pointer',
            width: 20,
            height: 20,
            padding: '2pt',
        },
    },
    divider: {
        background: theme.palette.primary.light,
        width: 1,
        minWidth: 1,
    },
    buttonGroup: {
        display: 'flex',
        marginBottom: 8,
        gap: '1px',
    },
}));
//# sourceMappingURL=collection-styles.js.map